"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _nextI18next = require("next-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ImageGalleryModal = _ref => {
  var {
    isModalOpen,
    onModalClose
  } = _ref;
  var baseTestId = 'ImageGalleryModal';
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  var modalBody = (0, _jsxRuntime.jsx)(_react.Box, {});
  return (0, _jsxRuntime.jsxs)(_react.Modal, {
    isOpen: isModalOpen,
    onClose: onModalClose,
    size: "full",
    closeOnEsc: true,
    closeOnOverlayClick: false,
    scrollBehavior: "inside",
    blockScrollOnMount: true,
    "data-testid": baseTestId,
    children: [(0, _jsxRuntime.jsx)(_react.ModalOverlay, {}), (0, _jsxRuntime.jsxs)(_react.ModalContent, {
      "data-testid": "".concat(baseTestId, "-Content"),
      children: [(0, _jsxRuntime.jsx)(_react.ModalHeader, {
        flexShrink: 0,
        p: 0,
        "data-testid": "".concat(baseTestId, "-Header"),
        children: (0, _jsxRuntime.jsx)(_react.Box, {
          bg: "lightGrey5",
          py: "xlg",
          px: {
            base: 'xlg',
            md: 'lg',
            lg: '5xl'
          },
          children: (0, _jsxRuntime.jsxs)(_react.HStack, {
            gap: "sm",
            alignItems: "center",
            onClick: onModalClose,
            cursor: "pointer",
            children: [(0, _jsxRuntime.jsx)(_atoms.Icon, _objectSpread({
              svg: (0, _jsxRuntime.jsx)(_atoms.ArrowLeft, {})
            }, headerIconProps)), (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, headerTextProps), {}, {
              children: t('hdp.imageGallery.modal.back')
            }))]
          })
        })
      }), (0, _jsxRuntime.jsx)(_react.ModalBody, {
        flex: 1,
        "data-testid": "".concat(baseTestId, "-Body"),
        children: modalBody
      })]
    })]
  });
};
var headerIconProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  w: 'var(--chakra-sizes-6)',
  h: 'var(--chakra-sizes-6)'
};
var headerTextProps = {
  fontWeight: 400,
  fontSize: {
    base: 'sm',
    sm: 'md'
  },
  lineHeight: {
    base: '2',
    sm: '3'
  }
};
var _default = exports.default = ImageGalleryModal;